import { useLearningObjectSEO } from '@hendrx/core/common/hooks/learningObject/useLearningObjectSEO';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import { requireCapability } from '@/app/_lib/guards/primitives';
import { loadDraftOrNotFound } from '@/app/_lib/loaders/loadDraftOrNotFound';

export const Route = createFileRoute('/studio')({
  beforeLoad: createRouteGuard(requireCapability('studio.access')),
  loader: ({ params }) => loadDraftOrNotFound(params),
  component: StudioLayout
});

function StudioLayout() {
  useLearningObjectSEO({});
  return <Outlet />;
}
